<template>
    <div class="xdf-toolbar-tabs" ref="xdf-toolbar-tabs">
        <!-- 在线咨询 -->
        <div class="toolbar-item backtop" @click="toogleZixun">
            <div class="out-con">
                <img
                    src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar8.png"
                    alt="联系客服"
                    style="margin-top: 10px"
                />
                <p style="color: #00b388">联系客服</p>
            </div>
        </div>

        <div class="split-line"></div>

        <!-- 购物车 -->
        <!-- <div
            class="toolbar-item xdf-cart"
            @mouseover="hoverCart(true)"
            @mouseleave="hoverCart(false)"
        >
            <a
                href="http://baoming.xdf.cn/ShoppingCart/indexShoopingCart.html"
                class="out-con"
            >
                <img
                    :src="
                        !cartHover
                            ? 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar1.png'
                            : 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar11.png'
                    "
                    alt="购物车"
                />
                <p>购物车</p>
            </a>
            <i class="cart-cnt">{{ cartNum }}</i>
        </div> -->

        <!-- <div class="split-line"></div> -->

        <!-- 约课表单 -->
        <div
            v-show="showCartForm"
            :class="[
                'toolbar-item',
                'xdf-sign-up',
                showForm ? 'xdf-sign-upOn' : '',
            ]"
            @mouseover="handleShowForm(true)"
            @mouseleave="handleShowForm(false)"
        >
            <div class="out-con">
                <img
                    :src="
                        !yuekeHover
                            ? 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar2.png'
                            : 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar21.png'
                    "
                    alt="免费预约"
                />
                <p>免费预约</p>
            </div>
            <form id="collectionForm">
                <div class="xdf-sign-up-container" v-show="showForm">
                    <div class="freeclass-box animate fadeIn">
                        <div class="freeclass-item">
                            <p
                                class="content"
                                id="areacity"
                                style="display: none"
                            >
                                <span> <b></b>城市 </span>
                                <select name="areacity">
                                    <option :value="cityName">
                                        {{ cityName }}
                                    </option>
                                </select>
                            </p>
                        </div>
                        <div class="freeclass-item">
                            <p class="content" id="name">
                                <input
                                    type="text"
                                    name="name"
                                    v-model="name"
                                    placeholder="请输入姓名"
                                    :class="name == '' ? 'bgGrey' : ''"
                                    autocomplete="off"
                                />
                                <!-- <span class="error" v-if="name !== ''">{{ nameError }}</span> -->
                            </p>
                        </div>
                        <div class="freeclass-item">
                            <p class="content" id="mobile">
                                <input
                                    type="text"
                                    name="mobile"
                                    v-model="mobile"
                                    placeholder="请输入手机号"
                                    :class="mobile == '' ? 'bgGrey' : ''"
                                    autocomplete="off"
                                />
                                <!-- <span class="error" v-if="phone !== ''">{{ phoneError }}</span> -->
                            </p>
                        </div>
                        <div class="freeclass-item">
                            <p class="content" id="captcha">
                                <input
                                    type="text"
                                    name="captcha"
                                    v-model="captcha"
                                    placeholder="请输入验证码"
                                    :class="phone == '' ? 'bgGrey' : 'captcha'"
                                    autocomplete="off"
                                />
                                <span class="getCaptcha" @click="getCaptcha">{{
                                    `${
                                        Number(counter) < 60
                                            ? `重新发送(${counter}秒)`
                                            : `发送验证码`
                                    }`
                                }}</span>
                            </p>
                        </div>
                        <div class="freeclass-item" id="course">
                            <div class="content">
                                <div
                                    class="freeclass-list"
                                    @click="showCourse1List"
                                >
                                    <span name="course1" ref="course1">{{
                                        course1
                                    }}</span>
                                    <img
                                        ref="narrow1"
                                        src="http://images.xdf.cn/cms20150819/zuixinban/images/freeclass_gwicon.png"
                                        alt
                                    />
                                    <ul
                                        :class="[
                                            'grade-list animated fadeIn',
                                            age == '' ? 'bgGrey' : '',
                                        ]"
                                        v-show="course1List"
                                        @click="handleCourse1"
                                    >
                                        <li
                                            v-for="item in courseListData"
                                            :key="item.value"
                                        >
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    class="freeclass-list"
                                    @click="showCourse2List"
                                    style="float: right"
                                >
                                    <span name="course2" ref="course2" style="    display: block; overflow: hidden;height: 100%;">{{
                                        course2
                                    }}</span>
                                    <img
                                        ref="narrow2"
                                        src="http://images.xdf.cn/cms20150819/zuixinban/images/freeclass_gwicon.png"
                                        alt
                                    />
                                    <ul
                                        :class="[
                                            'grade-list animated fadeIn',
                                            age == '' ? 'bgGrey' : '',
                                        ]"
                                        v-show="course2List"
                                        @click="handleCourse2"
                                    >
                                        <li
                                            v-for="item in courseListSecondData"
                                            :key="item.value"
                                        >
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="freeclass-terms">
                            <div
                                :class="[
                                    `terms-checkbox`,
                                    !isRead ? `terms-checkbox-not` : ``,
                                ]"
                                @click="
                                    () => {
                                        this.isRead = !this.isRead;
                                    }
                                "
                            ></div>
                            <label></label>
                            <div class="serviceInfo">
                                阅读并同意
                                <a
                                    href="http://opt.xdf.cn/collection/userlicense"
                                    target="_blank"
                                    >《用户服务条款》</a
                                >和
                                <a
                                    href="http://opt.xdf.cn/collection/privacypolicy"
                                    target="_blank"
                                    style="position: relative; left: -6px"
                                    >《隐私政策》</a
                                >
                            </div>
                        </div>

                        <div class="freeclass-item top5">
                            <div
                                class="submit-btn btn-success"
                                @click="submitForm"
                            >
                                免费约课
                            </div>
                        </div>

                        <p class="freeclass-notice">
                            约课后会有专业老师给您回电，请保持电话畅通。
                        </p>
                        <div class="triangle-right"></div>
                    </div>
                </div>
            </form>
        </div>

        <div class="split-line" v-show="showCartForm"></div>

        <!-- 移动端购课 -->
        <div
            class="toolbar-item xdf-oa"
            @mouseover="handleShowMCode(true)"
            @mouseleave="handleShowMCode(false)"
        >
            <div class="out-con">
                <img
                    :src="
                        !showMCode
                            ? 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar3.png'
                            : 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar31.png'
                    "
                    alt="移动端购课"
                />
                <p>移动端购课</p>
            </div>
            <div class="xdf-oa-container" v-show="showMCode">
                <div class="freeclass-box animate fadeIn">
                    <div class="freeclass-item">
                        <img
                            src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/mxdfcn.png"
                            alt="小程序二维码"
                            style="margin-top: 4px"
                        />
                        <div class="mp-title mp-title-mornal">移动版M站</div>
                    </div>
                    <div class="triangle-right"></div>
                </div>
            </div>
        </div>

        <div class="split-line"></div>

        <!-- 微信小程序 -->
        <div
            class="toolbar-item xdf-mp"
            @mouseover="handleShowMpCode(true)"
            @mouseleave="handleShowMpCode(false)"
        >
            <div class="out-con">
                <img
                    :src="
                        !showMpCode
                            ? 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar4.png'
                            : 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar41.png'
                    "
                    alt="小程序购课"
                />
                <p>小程序购课</p>
            </div>
            <div class="xdf-mp-container" v-show="showMpCode">
                <div class="freeclass-box animate fadeIn">
                    <div class="freeclass-item">
                        <img
                            src="http://images.xdf.cn/cms20150819/zuixinban/images/mpCode.png"
                            alt="小程序二维码"
                        />
                        <div class="mp-title">小程序购课</div>
                        <div class="mp-tag">
                            <span>·</span>更流畅 <span>·</span>更便捷
                            <span>·</span>更懂你
                        </div>
                    </div>
                    <div class="triangle-right"></div>
                </div>
            </div>
        </div>

        <div class="split-line"></div>

        <!-- 关注公众号 -->
        <div
            class="toolbar-item xdf-oa"
            @mouseover="handleShowOaCode(true)"
            @mouseleave="handleShowOaCode(false)"
        >
            <div class="out-con">
                <img
                    :src="
                        !showOaCode
                            ? 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar5.png'
                            : 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar51.png'
                    "
                    alt="关注公众号"
                />
                <p>关注公众号</p>
            </div>
            <div class="xdf-oa-container" v-show="showOaCode">
                <div
                    class="freeclass-box animate fadeIn"
                    style="height: 180px; padding-top: 4px"
                >
                    <div class="freeclass-item">
                        <img
                            src="http://file.xdf.cn/uploads/210204/182_210204172900Ekqf3UmJA7nafwzJ.png"
                            alt="关注公众号"
                            style="width: 138px"
                        />
                        <div class="oa-title">
                            扫码关注新东方网
                            <br />
                            <span style="color:#ef0520">即刻获得限量免费精品课</span>
                        </div>
                    </div>
                    <div class="triangle-right"></div>
                </div>
            </div>
        </div>

        <div class="split-line" v-show="scrollTop"></div>

        <!-- 返回顶部 -->
        <transition name="fade">
            <div
                class="toolbar-item backtop"
                v-show="scrollTop"
                @click="backtop"
                @mouseover="handleShowBack2Top(true)"
                @mouseleave="handleShowBack2Top(false)"
            >
                <div class="out-con">
                    <img
                        :src="
                            !showBack2Top
                                ? 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar6.png'
                                : 'http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar61.png'
                        "
                        alt="返回顶部"
                        style="margin-top: 22px"
                    />
                    <p>返回顶部</p>
                </div>
            </div>
        </transition>

        <!-- 咨询框 -->
        <div class="zixun-con" v-show="showZixun">
            <div class="zixun-header">
                <div class="title">
                    <img
                        src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar82.png"
                        alt="新东方"
                    />
                    <span>客服</span>
                </div>
                <div class="close" @click="toogleZixun">
                    <img
                        src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar83.png"
                        alt
                    />
                </div>
            </div>
            <div class="welcome">
                <img
                    src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar81.png"
                    alt="新东方小牛"
                />
                <div class="showText">
                    <p class="p1">
                        <img
                            src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar85.png"
                            alt="“"
                            style="
                                vertical-align: text-top;
                                margin-right: -13px;
                                position: relative;
                                left: -12px;
                            "
                        />
                        欢迎进入咨询页面
                    </p>
                    <p class="p2">
                        请选择咨询的学科吧!
                        <img
                            src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar86.png"
                            alt="”"
                            style="vertical-align: text-top; margin-left: 4px"
                        />
                    </p>
                </div>
            </div>
            <div
                :class="[
                    'content',
                    onlineconsultingList.length == 1
                        ? 'content1'
                        : onlineconsultingList.length == 2
                        ? 'content2'
                        : '',
                ]"
            >
                <div
                    class="item"
                    v-for="(item, index) in onlineconsultingList"
                    :key="`zxzx-${index}`"
                    @click="onZxzx(item)"
                >
                    <div class="title">{{ item.name }}</div>
                    <div class="zxzx">
                        <img
                            src="http://images.xdf.cn/cms20150819/zuixinban/images/sidebar/sidebar84.png"
                            alt="在线咨询"
                        />
                        <span>在线咨询</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
import { cityFormInfo } from "js/staticData.js";
import { getOnlineconsultingList } from "js/getSoukeData.js";
import { postClueId } from 'js/clueid.js'
export default {
    name: "Cart",
    timer: null, //定时器
    props: {
        showCartForm: Boolean,
    },
    data() {
        return {
            scrollTop: $(window).scrollTop(),
            cartNum: 0,
            formid: "",
            name: "",
            subject: "",
            phone: "",
            age: "小学",
            errInfo: "",
            showForm: false,
            showMpCode: false,
            gradeList: false,
            isBeijing: false,

            showMCode: false,
            cartHover: false,
            yuekeHover: false,
            showOaCode: false,
            showBack2Top: false,
            showZixun: false,
            onlineconsultingList: [],

            // 小表单数据
            isRead: true,
            instanceId: "4691",
            courseListData: [],
            courseListSecondData: [],
            course1: "",
            course2: "",
            course1List: false,
            course2List: false,
            mobile: "",
            captcha: "",
            counter: 60,
            areacity: "",
            course: "",
            cid: ''
        };
    },
    created() {
        let cid = this.$cookies.get("soukecityid");
        let cname = this.$cookies.get("cityName");
        this.$store.commit("selectCity", { cid, cname });

        this.splitV4CartStr(this.getV4cart);

        if (
            cid ||
            cid != null ||
            cid != "null" ||
            cid != undefined ||
            cid != "undefined" ||
            !isNaN(Number(cid))
        ) {
            if (Number(cid) == 1) {
                this.isBeijing = true;
            }
        }

        this.getOptData(this.instanceId);
    },
    mounted() {
        window.addEventListener("scroll", this.scrollHandle);

        // console.warn("mounted成功-----调的在线客服");
        this.getOnlineconsultingLists(this.$cookies.get("soukecityid"));
    },
    computed: {
        ...mapState(["soukecityId", "cityName"]),

        cityId() {
            return this.$store.state.soukecityId;
        },
        getV4cart() {
            return this.$cookies.get("Xdf.WebPay.V4.Cart");
        },
        checkNickName() {
            let nickName = this.$cookies.get("U2NickName");
            if (nickName !== null && nickName !== "null" && nickName !== "") {
                return true;
            } else {
                return false;
            }
        },
    },
    watch: {
        cityId(newVal) {
            if (newVal) {
                // console.warn("watch到新值=====调的在线客服");
                this.getOnlineconsultingLists(newVal);
                this.formid = cityFormInfo[newVal].pcformId;
                if (Number(newVal) == 1) {
                    this.isBeijing = true;
                }
                return newVal;
            }
        },
        getV4cart(newVal) {
            if (newVal) {
                this.splitV4CartStr(newVal);
            }
        },
    },
    methods: {
        scrollHandle() {
            this.scrollTop = $(window).scrollTop();
        },
        backtop() {
            $("html").animate({ scrollTop: 0 }, 300);
            $("body").animate({ scrollTop: 0 }, 300);
        },
        handleCourse1(e) {
            if (e.target.nodeName === "LI") {
                this.course1 = e.target.innerHTML;
                this.$refs["course1"].value = e.target.innerHTML;
                this.courseListSecondData = this.courseListData.filter((item) => item.name == e.target.innerHTML.trim())[0].children;
                this.course1List = "false";
                this.course2 = this.courseListSecondData[0].name;
            }
        },
        handleCourse2(e) {
            if (e.target.nodeName === "LI") {
                this.course2 = e.target.innerHTML;
                if (this.$refs["course2"])
                    this.$refs["course2"].value = e.target.innerHTML;
                this.course2List = "false";
            }
        },
        showCourse1List() {
            if (this.course1List) {
                this.course1List = false;
                this.$refs["narrow1"].style.transform = "rotate(0deg)";
            } else {
                this.course1List = true;
                this.$refs["narrow1"].style.transform = "rotate(180deg)";
            }
        },
        showCourse2List() {
            if (this.course2List) {
                this.course2List = false;
                this.$refs["narrow2"].style.transform = "rotate(0deg)";
            } else {
                this.course2List = true;
                this.$refs["narrow2"].style.transform = "rotate(180deg)";
            }
        },
        handleShowForm(show) {
            this.showForm = show;
            this.yuekeHover = show;
        },
        closeModel() {
            this.showForm = false;
        },
        splitV4CartStr(cartStr) {
            if (cartStr !== undefined && cartStr !== "" && cartStr !== null) {
                $("#kInfo").empty();
                let cartArr = cartStr.toString().split("|");
                this.cartNum = cartArr.length;
                let Price = 0;
                for (let i = 0; i < this.cartNum; i++) {
                    let cartInfo = cartArr[i].split(",");
                    Price += parseInt(cartInfo[4]);
                    $(".u-price").html("￥" + Price);
                    $("#kInfo").append(
                        `<li style='width:300px;'><a target='_blank' href='http://souke.xdf.cn/ClassDirect.aspx?sid=${
                            cartInfo[2]
                        }&code=${cartInfo[0]}'>${decodeURIComponent(
                            cartInfo[1]
                        )}-${cartInfo[0]}</a></li>`
                    );
                }
                if (this.cartNum > 0) {
                    $(".J-nub").show().html(this.cartNum);
                    $("#gnum").html(this.cartNum);
                } else {
                    $(".J-nub").hide().html("");
                    $("#gnum").html("");
                }
                $(".Gnum").html(`共<i>${this.cartNum}</i>个班级`);
            }
        },
        handleShowMCode(show) {
            this.showMCode = show;
        },
        handleShowMpCode(show) {
            this.showMpCode = show;
        },
        hoverCart(show) {
            this.cartHover = show;
        },
        handleShowOaCode(show) {
            this.showOaCode = show;
        },
        handleShowBack2Top(show) {
            this.showBack2Top = show;
        },
        toogleZixun() {
            this.showZixun = !this.showZixun;
        },
        getOnlineconsultingLists(cid) {
            //单独对不是正常的cid做过滤筛选
            if (
                !cid ||
                cid == null ||
                cid == "null" ||
                cid == undefined ||
                cid == "undefined" ||
                isNaN(Number(cid))
            ) {
                return false;
            }
            getOnlineconsultingList(cid).then((res) => {
                if (res.status == 1 || Number(res.code) == 200) {
                    this.onlineconsultingList = res.data;
                    this.showZixun = true;
                } else {
                    alert(res.message);
                }
            });
        },
        onZxzx(item) {
            if (item.easemobConfig) {
                easemobim.bind(eval("(" + item.easemobConfig + ")"));
                return false;
            }
            if (item.consultingUrl) {
                window.open(item.consultingUrl);
            }
        },
        //获取表单数据
        getOptData(instanceId) {
            $.ajax({
                url: "http://opt-backend.xdf.cn/opt/core/show",
                data: JSON.stringify({
                    instanceId: instanceId,
                }),
                type: "POST",
                dataType: "json",
                headers: {
                    "content-type": "application/json",
                },
                success: (res) => {
                    // console.log("success", res);
                    if (res.success) {
                        let thisValue;
                        try {
                            thisValue = JSON.parse(res.data.value);
                        } catch (error) {
                            console.log("转换JSON失败", error);
                        }
                        this.optName=thisValue.title;
                        let temp = thisValue.formList.filter(
                            (item) => item.key == "course"
                        );
                        if (temp[0] && temp[0].defaultValue) {
                            let courseListData = temp[0].defaultValue;
                            this.courseListData = courseListData.map((ii) => {
                                let children = [];
                                ii.children.map((jj) => {
                                    if (jj.children) {
                                        children = children.concat(jj.children);
                                    } else {
                                        children.push(jj);
                                    }
                                });
                                return {
                                    ...ii,
                                    children: [...children],
                                };
                            });
                            this.course1=this.courseListData[0].name;
                            this.courseListSecondData=this.courseListData[0].children;
                            this.course2=this.courseListData[0].children[0].name;
                            // this.courseListData=temp[0].defaultValue;
                            // console.log(11111,this.courseListData)
                        }
                    } else {
                        console.log(res.errorMsg);
                    }
                    // console.log(111111, this.courseListData);
                },
                error: (res) => {
                    console.log("error", res);
                },
            });
        },
        //提交数据
        submitForm() {
            let { instanceId,optName, cityName,name, mobile, captcha, course1, course2 } = this;
            var data = {
                instanceId,
                optName,
                optUrl: "https://m.xdf.cn/opt/?state=" + instanceId,
                source: window.location.href,
                token: "",
                areacity:cityName,
                name,
                mobile,
                captcha,
                course: `${course1.trim()}/${course2.trim()}`,
            };

            if (!data.areacity) {
                data.areacity = this.$cookies.get("cityName");
            }
            if (!data.areacity) {
                alert("请确认选择城市后再提交。");
                return false;
            }

            var canSubmit = true;

            if (!data.name.trim()) {
                alert("请先填写姓名后再提交！");
                return false;
            }

            if (!data.mobile.trim()) {
                alert("请先填写手机号后再提交！");
                return false;
            }

            if (!data.captcha.trim()) {
                alert("请先填写验证码后再提交！");
                return false;
            }

            if (!course1 || !course2) {
                alert("请先填选择课程后再提交！");
                return false;
            }

            if (!this.isRead) {
                alert("请确认勾选用户服务条款和隐私协议!");
                return false;
            }

            let _this = this;
            // return false;
            $.ajax({
                url: "https://opt-backend.xdf.cn/opt/core/submit",
                data: JSON.stringify(data),
                type: "POST",
                dataType: "json",
                headers: {
                    "content-type": "application/json",
                },
                success: function (res) {
                  // console.log(res);
                    if (res.success) {
                        alert("提交成功，请保持电话畅通！");

                      postClueId(_this.cityId, res.data)
                    } else {
                        alert(res.errorMsg);
                    }
                    console.log("success", res);
                },
                error: function (e) {},
            });
        },
        //发送验证码
        getCaptcha() {
            if (!this.mobile) {
                alert("请先填写手机号！");
                return false;
            }

            if (!/^(1[0-9])\d{9}$/.test(this.mobile.trim())) {
                alert("请正确填写手机号！");
                return false;
            }

            if (this.counter < 60) {
                return false;
            }

            let thisTimer = setInterval(() => {
                if (this.counter <= 0) {
                    this.counter = 60;
                    clearInterval(thisTimer);
                    return true;
                }
                this.counter--;
            }, 1000);

            $.ajax({
                url: "https://opt-backend.xdf.cn/opt/sms/captcha",
                data: JSON.stringify({
                    mobile: this.mobile,
                }),
                type: "POST",
                dataType: "json",
                headers: {
                    "content-type": "application/json",
                },
                success: function (res) {
                    if (res.success) {
                        // alert("发送成功");
                    }
                    // console.log("success", res);
                },
                error: function (err) {
                    console.log("error", err);
                },
            });
        },
    },
};
</script>

<style lang="stylus">
.xdf-toolbar-tabs {
    position: fixed;
    top: 40%;
    right: 0px;
    margin-top: -90px;
    z-index: 2;
    width: 79px;
    // min-height: 380px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(148, 148, 148, 0.2);
    border-radius: 4px 0px 0px 4px;

    .split-line {
        width: 62px;
        height: 1px;
        background: rgba(230, 230, 230, 1);
        margin: 0 auto;
    }

    & > div.toolbar-item {
        width: 79px;
        height: 76px;
        // color: #fff;
        // float: right;
        position: relative;
        font-size: 14px;

        // cursor: pointer;
        .out-con {
            display: block;
            height: 100%;
            text-align: center;
            cursor: pointer;

            img {
                margin-top: 17px;
            }

            p {
                color: #333333;
                font-size: 12px;
                line-height: 26px;
            }
        }

        &:hover {
            background: #00B388;

            .out-con {
                p {
                    color: #fff;
                }
            }
        }
    }

    .xdf-cart {
        display: block;

        .cart-cnt {
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            position: absolute;
            border-radius: 50%;
            border: 1px solid #fff;
            background: #ff4800;
            right: 12px;
            top: 8px;
            z-index: 1;
            color: #fff;
        }
    }

    .xdf-sign-up {
        position: relative;

        .freeclass-box {
            width: 233px;
            border: 1px solid rgba(224, 224, 224, 1);
            box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.19);
            border: 1px solid #e0e0e0;
            background-color: #ffffff;
            color: #808080;
            padding-top: 8px;
            font-size: 14px;
            z-index: 3;

            .closeModel {
                width: 20px;
                height: 20px;
                position: absolute;
                right: 5px;
                top: 5px;
                cursor: pointer;
                background: url('http://images.xdf.cn/cms20150819/zuixinban/images/x.png') no-repeat center; // images.xdf.cn/cms20150819/zuixinban/images/x.png) no-repeat center
            }

            .freeclass-item {
                width: 197px;
                margin: 10px auto 0px;
                position: relative;

                .content {
                    flex: 1;
                    position: relative;

                    input {
                        width: 195px;
                        height: 30px;
                        line-height: 32px;
                        text-indent: 6px;
                        color: #333;
                        font-size: 12px;
                        border: 1px solid rgba(233, 233, 233, 1);
                        border-radius: 2px;

                        // letter-spacing: 2px;
                        &:hover {
                            border: 1px solid #69c2ad;
                        }

                        &:focus {
                            background: #fff;
                        }

                        &::-webkit-input-placeholder {
                            color: #b5b5b5;
                            font-size: 12px;
                        }

                        &::-moz-placeholder {
                            color: #b5b5b5;
                            font-size: 12px;
                        }

                        &:-moz-placeholder {
                            color: #b5b5b5;
                            font-size: 12px;
                        }

                        &:-ms-input-placeholder {
                            color: #b5b5b5;
                            font-size: 12px;
                        }
                    }

                    .getCaptcha {
                        position: absolute;
                        //top: 11px;
                        top: 7px;
                        right: 10px;
                        font-size: 12px;
                        color: rgb(0, 179, 136);
                        cursor: pointer;
                    }

                    .error {
                        width: 100%;
                        line-height: 16px;
                        display: inline-block;
                        position: absolute;
                        color: red;
                        bottom: -15px;
                        left: 10px;
                        font-size: 12px;
                    }
                }

                .freeclass-list {
                    position: relative;
                    width: 97px;
                    height: 32px;
                    cursor: pointer;
                    display: inline-block;
                    line-height: 32px;
                    padding-left: 6px;
                    font-size: 12px;
                    color: #333;
                    border: 1px solid rgba(233, 233, 233, 1);
                    background-color: #fff;
                    animation-duration: 0.3s;
                    box-sizing: border-box;

                    // letter-spacing: 2px;
                    &:hover {
                        border: 1px solid #69c2ad;
                    }

                    &:focus {
                        background: #fff;
                    }

                    span {
                        // color:#999
                    }

                    img {
                        position: absolute;
                        right: 10px;
                        top: 12px;
                        transition: transform 0.3s;
                    }

                    .grade-list {
                        width: 160px;
                        top: 30px;
                        height: 150px;
                        overflow-y: scroll;
                        left: -1px;
                        z-index: 1;
                        border-bottom: none;
                        position: absolute;
                        animation-duration: 0.2s;
                        background-color: #fff;
                        border: 1px solid rgba(233, 233, 233, 1);
                        box-sizing: border-box;

                        & > li {
                            height: 30px;
                            line-height: 30px;
                            border-bottom: 1px solid #eeeeee;
                            background-color: #FFF;
                            color: #333;
                            padding-left: 8px;
                            font-size: 12px;

                            &:hover {
                                background: #47bea1;
                                color: #fff;
                            }

                            // &:last-child{
                            //   border-bottom: none;
                            // }
                        }
                    }
                }
            }

            .top5 {
                margin-top: 16px;
            }

            .bgGrey {
                background: #fafafa;
            }

            .errInfo {
                width: 197px;
                // height: 20px;
                background-color: #fff;
                border: 1px;
                font-size: 12px;
                color: #fd4614;
                margin: 7px auto 0px;
                line-height: 16px;

                .sigh {
                    width: 14px;
                    height: 14px;
                    display: inline-block;
                    border-radius: 7px;
                    color: #fff;
                    background: #fd4614;
                    text-align: center;
                    font-weight: bold;
                }

                span {
                    position: relative;
                    top: 0px;
                }
            }

            .submit-btn {
                display: block;
                cursor: pointer;
                width: 197px;
                height: 33px;
                background-color: #66d1b8;
                border-radius: 2px;
                color: #FFF;
                margin: 0 auto;
                text-align: center;
                line-height: 31px;
                font-size: 14px;
            }

            .btn-success {
                background-color: #00b388;
            }

            .triangle-right {
                width: 0;
                height: 0;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
                border-left: 6px solid #ffffff;
                position: absolute;
                top: 105px;
                right: -3px;
            }
        }

        .freeclass-notice {
            margin-top: 11px;
            padding: 6px 20px;
            font-size: 12px;
            color: #999;
            background-color: #ddfffb;
            line-height: 16px;
        }

        .freeclass-terms {
            margin: 10px auto 0px;
            font-size: 12px;
            color: #999;
            line-height: 14px;
            position: relative;
            width: 197px;

            a {
                color: #00b388;
            }

            #userlicense_check {
                display: none;
            }

            .terms-checkbox {
                width: 14px;
                height: 14px;
                border: 0px solid #fff;
                background-color: #fff;
                background: url('http://images.xdf.cn/cms20150819/zuixinban/images/www_yueke.png') no-repeat;
                // background-size:14px 14px
                background-position: 0 -14px;
                display: inline-block;
                position: relative;
                top: -15px;
                letter-spacing: 0px;
            }

            .terms-checkbox-not {
                background: url('http://images.xdf.cn/cms20150819/zuixinban/images/www_yueke.png') no-repeat;
                background-position: 0 0px;
            }

            .serviceInfo {
                width: 178px;
                display: inline-block;
                line-height: 18px;

                a {
                    margin: 0 2px;
                }
            }
        }
    }

    .h303 {
        height: 303px !important;
    }

    .backtop {
        &:hover {
            background: #fff !important;

            .out-con {
                p {
                    color: #00B388 !important;
                }
            }
        }
    }

    .xdf-mp {
        position: relative;

        .freeclass-box {
            width: 174px;
            height: 206px;
            box-shadow: 1px 5px 10px 1px rgba(0, 0, 0, 0.19);
            border: 1px solid #e0e0e0;
            background-color: #ffffff;
            // position: absolute
            // top: -90px
            // right: 52px
            color: #333;
            padding-top: 10px;
            font-size: 12px;
            display: flex;
            z-index: 3;
            flex-direction: column;

            .freeclass-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                width: 174px;
                height: 42px;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                position: relative;

                img {
                    width: 136px;
                    height: 136px;
                }

                .mp-title {
                    line-height: 20px;
                    color: #00b388;
                    font-size: 15px;
                    border-bottom: 1px solid #e8e8e8;
                    width: 154px;
                    text-align: center;
                    padding-bottom: 5px;
                    margin-bottom: 3px;
                    margin-top: 10px;
                }

                .mp-title-mornal {
                    font-size: 14px;
                    border-bottom: none;
                }

                .mp-tag {
                    line-height: 20px;
                    font-size: 12px;
                    color: #808080;

                    // position: relative;
                    // left: 2px;
                    span {
                        font-size: 20px;
                        font-weight: bold;
                        color: #47bea1;
                        vertical-align: bottom;
                        margin: 0 2px;
                    }
                }
            }

            .triangle-right {
                width: 0;
                height: 0;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
                border-left: 6px solid #ffffff;
                position: absolute;
                top: 100px;
                right: 5px;
            }
        }
    }

    .xdf-oa {
        position: relative;

        .xdf-oa-container {
            background-color: rgba(0, 0, 0, 0);
            width: 152px;
            height: 168px;
            position: absolute;
            top: -50px;
            right: 73px;

            .freeclass-box {
                width: 144px;
                // height: 150px;
                box-shadow: 1px 5px 10px 1px rgba(0, 0, 0, 0.19);
                border: 1px solid #e0e0e0;
                background-color: #ffffff;
                color: #333;
                padding-top: 10px;
                font-size: 12px;
                display: flex;
                z-index: 3;
                flex-direction: column;

                .freeclass-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    img {
                        width: 119px;
                        // height: 119px;
                    }

                    .mp-title {
                        line-height: 20px;
                        color: #00b388;
                        font-size: 14px;
                        text-align: center;
                        padding-bottom: 5px;
                        margin-top: 5px;
                    }

                    .oa-title {
                        line-height: 20px;
                        color: #333333;
                        font-size: 12px;
                        text-align: center;
                        padding-bottom: 5px;
                        line-height: 17px;

                        span {
                            color: #00b388;
                        }
                    }
                }

                .triangle-right {
                    width: 0;
                    height: 0;
                    border-top: 10px solid transparent;
                    border-bottom: 10px solid transparent;
                    border-left: 6px solid #ffffff;
                    position: absolute;
                    top: 78px;
                    right: 1px;
                }
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    .xdf-toolbar-tabs {
        right: 660px;
    }
}

.xdf-sign-up-container {
    background-color: rgba(0, 0, 0, 0);
    width: 237px;
    // height: 304px
    position: absolute;
    top: -78px;
    right: 77px;
}

.xdf-mp-container {
    background-color: rgba(0, 0, 0, 0);
    width: 186px;
    height: 206px;
    position: absolute;
    top: -73px;
    right: 69px;
}

.zixun-con {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 440px;
    // height: 433px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.19);
    z-index: 2;

    .zixun-header {
        width: 440px;
        height: 44px;
        box-sizeing: border-box;
        background: rgba(0, 179, 136, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            color: #fff;
            padding: 0 14px;

            span {
                font-size: 16px;
                margin-left: 6px;
                position: relative;
                top: 3px;
            }
        }

        .close {
            cursor: pointer;
            padding-right: 14px;
        }
    }

    .welcome {
        padding: 17px 0 5px 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .showText {
            padding-top: 10px;
            padding-left: 22px;

            .p1 {
                font-size: 14px;
                color: rgba(0, 161, 122, 1);
                line-height: 21px;
            }

            .p2 {
                font-size: 11px;
                color: rgba(102, 102, 102, 1);
                line-height: 16px;
            }
        }
    }

    .content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 20px 18px 50px 18px;

        .item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            width: 128px;
            height: 69px;
            background: rgba(236, 250, 247, 1);
            border-radius: 4px;
            margin-top: 17px;
            margin-right: 10px;

            &:nth-child(3n) {
                margin-right: 0px;
            }

            &:nth-child(1) {
                margin-top: 0px;
            }

            &:nth-child(2) {
                margin-top: 0px;
            }

            &:nth-child(3) {
                margin-top: 0px;
            }

            &:hover {
                cursor: pointer;

                .title {
                    color: rgba(0, 179, 136, 1);
                }
            }

            .title {
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
            }

            .zxzx {
                margin-top: 10px;
                font-size: 12px;
                color: rgba(0, 179, 136, 1);

                img {
                    vertical-align: text-top;
                }
            }
        }
    }

    .content1 {
        justify-content: center;

        .item {
            flex: 1;
            margin-right: 0px;
        }
    }

    .content2 {
        justify-content: center;

        .item {
            flex: 1;

            &:nth-child(2) {
                margin-right: 0px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common-components/Cart.vue